import ProfileClient from '@atlaskit/profilecard/profile-card-client';

/**
 * Creates a shared ProfileClient instance with consistent configuration
 * Used across knowledge card components to avoid duplication
 */
export const createProfileClient: (cloudId: string) => ProfileClient = (
	cloudId: string,
): ProfileClient =>
	new ProfileClient({
		url: '/gateway/api/directory/graphql',
		productIdentifier: 'rovo',
		cloudId,
	});
